export default __webpack_public_path__ + "static/media/loader.c5d68b48.gif";